const e=e=>e&&Array.isArray(e)&&0!==e.length?e.reduce(((e,r)=>r.roleName?(e[r.roleName]||(e[r.roleName]=[]),e[r.roleName].push(r),e):e),{}):{};export{e as groupByRoles};
//# sourceMappingURL=groupBy.js.map
